const vimeoPartsFromLink = (url = '') => {
  const raw = String(url || '').trim()
  if (!raw) return { id: '', hash: '' }

  const externalMatch = raw.match(/\/external\/(\d+)/)
  if (externalMatch) return { id: externalMatch[1], hash: '' }

  const progressiveMatch = raw.match(/\/progressive_redirect\/playback\/(\d+)/)
  if (progressiveMatch) return { id: progressiveMatch[1], hash: '' }

  const parsePath = (path = '', searchParams) => {
    const parts = path.split('/').filter(Boolean)
    const videoIndex = parts.findIndex((part) => /^\d+$/.test(part))
    const id = videoIndex >= 0 ? parts[videoIndex] : ''
    const hashFromPath =
      videoIndex >= 0 && parts[videoIndex + 1] && !/^\d+$/.test(parts[videoIndex + 1])
        ? parts[videoIndex + 1]
        : ''
    return {
      id,
      hash: searchParams?.get('h') || hashFromPath || '',
    }
  }

  try {
    const parsed = new URL(raw)
    if (parsed.hostname.includes('vimeo.com')) {
      return parsePath(parsed.pathname, parsed.searchParams)
    }
  } catch (e) {
    // Fall through to support raw IDs and path fragments.
  }

  const rawIdMatch = raw.match(/^(\d+)(?:[/?#]|$)/)
  if (rawIdMatch) {
    const hashMatch = raw.match(/(?:[?&]h=|\/)([A-Za-z0-9]+)(?:[&#?]|$)/)
    return { id: rawIdMatch[1], hash: hashMatch?.[1] || '' }
  }

  const anyVimeoIdMatch = raw.match(/vimeo\.com\/(?:.*\/)?(\d+)(?:$|[/?#])/)
  return { id: anyVimeoIdMatch?.[1] || raw, hash: '' }
}

const normalizeVimeoFileUrl = (url = '') => String(url || '').trim()

const isVimeoFileUrl = (url = '') => {
  const value = String(url || '').toLowerCase()
  return value.includes('.mp4') || value.includes('progressive_redirect/playback')
}

const isVimeoPageUrl = (url = '') => {
  const value = String(url || '').toLowerCase()
  return value.includes('vimeo.com') && !isVimeoFileUrl(value)
}

const getVimeoEmbedUrl = (vimeoId, params = {}) => {
  const { id, hash } = vimeoPartsFromLink(vimeoId)
  if (!id) return ''

  const query = new URLSearchParams()
  if (hash) query.set('h', hash)
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== false) {
      query.set(key, String(value))
    }
  })

  const search = query.toString()
  return `https://player.vimeo.com/video/${id}${search ? `?${search}` : ''}`
}

const getVimeoPageUrl = (vimeoId) => {
  const { id, hash } = vimeoPartsFromLink(vimeoId)
  if (!id) return ''
  return `https://vimeo.com/${id}${hash ? `/${hash}` : ''}`
}

const getVimeoMeta = (vimeoId) => {
  const { id, hash } = vimeoPartsFromLink(vimeoId)
  if (!id) return null
  const pageUrl = `https://vimeo.com/${id}${hash ? `/${hash}` : ''}`
  return `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(pageUrl)}`
}

const fetcher = (...args) => fetch(...args).then((res) => res.json())

const vimeoIdFromLink = (url) => {
  const { id, hash } = vimeoPartsFromLink(url)
  if (!id) return ''
  return hash ? `${id}?h=${hash}` : id
}

const openLinksNewTab = () => {
  const { links } = document
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank'
      links[i].setAttribute('rel', 'noopener noreferrer')
      links[i].className += ' link-external'
    } else {
      links[i].className += ' link-local'
    }
  }
}

export {
  getVimeoMeta,
  getVimeoEmbedUrl,
  getVimeoPageUrl,
  isVimeoFileUrl,
  isVimeoPageUrl,
  normalizeVimeoFileUrl,
  fetcher,
  vimeoIdFromLink,
  openLinksNewTab,
}
